import React from "react";
import { Box, Grid } from "@mui/material";
import BodyInformationRightSide from "../../../../common/bodymap/bodyInformationRightSide";
import BodySkinMapMale from "../../../../common/bodymap/bodyPartSelection";

const BodyMapBoy = ({ medicalData, setMedicalData, setUploadedImages }) => {
  const handleUploadedImages = (data) => {
    setUploadedImages(data);
  };

  const handleMedicalDataChange = (key, value) => {
    setMedicalData((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <Box sx={{ maxWidth: 1000, mx: "auto", p: 3 }}>
      <Grid container spacing={2}>
        <Grid item lg={6} md={6}>
          <BodySkinMapMale onUpload={handleUploadedImages} />
        </Grid>
        <Grid item lg={6} md={6} mt={20}>
          {/* Right Column - Medical Information */}
          <BodyInformationRightSide medicalData={medicalData} onDataChange={handleMedicalDataChange} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BodyMapBoy;
